import React from "react";
import styled from "styled-components";
import breakpoints from "../constants/breakpoints";
import { siteColors } from "../constants/colors";
import { AdaptiveHostedVideo } from "./hosted-video.js";
import {
  Band,
  BandTextContainer,
  BandTextHeader,
  BandBodyText,
} from "./band";
import { VideoContainer, VideoInnerContainer } from "./ephemeral-video-container.js";

const TextMarginTopAdjustmentContainer = styled.div`
   margin-top: -2.5em;

  @media (max-width: ${ breakpoints.desktopSmallHD }px) {
   margin-top: 2.0em;
  }
`;

const VideoMarginAdjustmentContainer = styled.div`
   margin-right: 6.5em;
   margin-left: -6.5em;

  @media (max-width: ${ breakpoints.desktopSmallHD }px) {
   margin-right: 0.0em;
   margin-left: 0.0em;
  }
`;

const RigWithRulesBandBand = () => (
  <Band background={siteColors.darker}>
    <BandTextContainer>
        <TextMarginTopAdjustmentContainer>
      <BandTextHeader>
        Rig with Rules
      </BandTextHeader>
      <BandBodyText>
        Traditional rigging makes the rigger manually specify every behavior the
    rig might need, and how those behaviors affect each other. The result is
    rigs that are slow, complex, and hard to maintain.
      </BandBodyText>
      <BandBodyText>
        So we went back to the drawing board on rigging and came up with a
    unique contextual rig solver. The rigger just tells each control what kinds
    of relationships it could have with other controls, and then, at runtime,
    this simple specification expands into potentially thousands of possible
    ways for an animator to interact with the rig!
      </BandBodyText>
        </TextMarginTopAdjustmentContainer>
    </BandTextContainer>
        <VideoContainer>
        <VideoInnerContainer>
        <VideoMarginAdjustmentContainer>
        <AdaptiveHostedVideo url="https://www.youtube.com/embed/AaPCPYKYeHg?si=AOeq9f0JWU6ANZyH" title="Rig With Rules" />
        </VideoMarginAdjustmentContainer>

        </VideoInnerContainer>
        </VideoContainer>
  </Band>
);

export default RigWithRulesBandBand;
